/** SSR-safe JSON-LD script. Renders in the document body so it stays next to the UI it describes. */
export function JsonLd({ data }: { data: unknown }) {
  return (
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />
  );
}
